import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';

import { doGetProfile } from '../stores/thunk';
import MainLayout from '../../../Layouts/Main';
import PartnerLayout from '../../../Layouts/PartnerLayout';
import ChangePasswordModal from '../../../components/ChangePasswordModal';

const Container = ({ allowedRoles, children }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const error = useSelector((state) => state.common.error);

  useEffect(() => {
    if (auth && auth.authenticated && !auth.user) {
      dispatch(doGetProfile());
    }
  }, []);

  if (auth && auth.authenticated && error?.statusCode === 401) {
    return <Navigate to="/logout" />;
  }

  const role = auth.user?.role?.toLowerCase();
  const mustChangePassword = auth.mustChangePassword || auth.user?.mustChangePassword;

  if (auth && auth.authenticated && !auth.user) return <Spin style={{ paddingTop: 100, width: '100%' }} />;
  if (auth && auth.authenticated) {
    const roleMatches = allowedRoles?.includes(role) || (role === 'superadmin' && allowedRoles?.includes('admin'));

    if (roleMatches) {
      const layout =
        role === 'partner_viewer' ? (
          <PartnerLayout>{children}</PartnerLayout>
        ) : (
          <MainLayout isHeaderFooter={role === 'admin' || role === 'superadmin'}>{children}</MainLayout>
        );

      return (
        <>
          {mustChangePassword && <ChangePasswordModal open forced />}
          {children && layout}
        </>
      );
    } else {
      if (role === 'partner_viewer') {
        return <Navigate to="/partner" />;
      }
      return <Navigate to={role === 'user' ? '/' : '/admin/'} />;
    }
  } else {
    return <Navigate to="/login" />;
  }
};

export default Container;
